export default {
	'restore-path': 'استعادة المسار',
	'delete-path': 'حذف المسار',
	'select-vehicle': 'رجاءً، قم باختيار عربة أولاً',
	contextmenu: {
		'add-point': 'إضافة نقطة',
		'remove-point': 'حذف نقطة'
	}
}